import { LDProvider } from 'launchdarkly-react-client-sdk'
import { type PropsWithChildren } from 'react'

import { useQueryGetUserLogged } from '../../../../flecto-core/shared'

export type FeatureFlagsProviderProps = PropsWithChildren & {
  withUserIdentification?: boolean
}

export function FeatureFlagsProvider({
  children,
  withUserIdentification = false,
}: FeatureFlagsProviderProps) {
  const { data: user } = useQueryGetUserLogged({
    enabled: withUserIdentification,
  })

  const context = {
    kind: 'user',
    key: user?.email ?? '',
    email: user?.email ?? '',
  }

  return (
    <LDProvider
      clientSideID={process.env.NEXT_PUBLIC_LD_CLIENT_ID ?? ''}
      context={context}
    >
      {children}
    </LDProvider>
  )
}
